import React, { useEffect, useMemo, useState } from 'react';
type CountdownProps = {
  hours?: number;
  size?: 'md' | 'lg';
};
function pad(value: number) {
  return String(value).padStart(2, '0');
}
export function Countdown({
  hours = 24,
  size = 'lg'
}: CountdownProps) {
  const target = useMemo(() => Date.now() + hours * 60 * 60 * 1000, [hours]);
  const [remaining, setRemaining] = useState(() => Math.max(0, target - Date.now()));
  useEffect(() => {
    const id = window.setInterval(() => {
      setRemaining(Math.max(0, target - Date.now()));
    }, 1000);
    return () => window.clearInterval(id);
  }, [target]);
  const totalSeconds = Math.floor(remaining / 1000);
  const units = [{
    value: pad(Math.floor(totalSeconds / 3600)),
    label: 'Hours'
  }, {
    value: pad(Math.floor(totalSeconds % 3600 / 60)),
    label: 'Min'
  }, {
    value: pad(totalSeconds % 60),
    label: 'Sec'
  }];
  return <div className="flex items-stretch justify-center gap-2 sm:gap-3" role="timer" aria-live="off" data-id="element-62" data-mp="15b698bho4bv7">
      {units.map((unit, i) => <React.Fragment key={unit.label} data-id="element-63" data-mp="xzc0rxymghno" data-mpi={i}>
          <div className="min-w-[4.5rem] border border-line bg-night px-3 py-3 text-center sm:min-w-[6rem] sm:px-5 sm:py-4" data-id="element-64" data-mp="t2d9roa98qtp">
            <span className={['block font-display font-extrabold leading-none text-acid tabular-nums', size === 'lg' ? 'text-4xl sm:text-5xl' : 'text-3xl sm:text-4xl'].join(' ')} data-id="element-65" data-mp="17py9r9bu29xe">
              {unit.value}
            </span>
            <span className="mt-1.5 block text-[10px] font-semibold uppercase tracking-[0.2em] text-white/40" data-id="element-66" data-mp="a496vbkyno0c">
              {unit.label}
            </span>
          </div>
          {i < units.length - 1 && <span className="self-center font-display text-2xl font-bold text-white/25" aria-hidden="true" data-id="element-67" data-mp="jzu5czqtm65c">
              :
            </span>}
        </React.Fragment>)}
    </div>;
}